import { render, staticRenderFns } from "./ProjectChangeEmailCreate.vue?vue&type=template&id=b8dbda46&"
import script from "./ProjectChangeEmailCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectChangeEmailCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports